module.exports = __webpack_public_path__ + "static/media/spinner.7feb48ca.svg";